import { put, takeLatest } from "redux-saga/effects";
import { push } from "redux-first-history";

import { CONTENT_PLAYLISTS_ROUTE } from "@ds/constants/router";

import { contentActions } from "./slice";

function* switchRoute() {
  yield put(push(CONTENT_PLAYLISTS_ROUTE));
}

export function* watchCommon() {
  yield takeLatest(contentActions.switchView, switchRoute);
}
